import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import BannersTable from "../../components/Banners/BannersTable";

const BannersPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="Banners" />
        <BannersTable />
      </MasterLayout>
    </>
  );
};

export default BannersPage;